import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../common/config';
import HandwriteCircle from '../common/components/svg/HandwriteCircle';
import useFlavorStore from '../common/store/useFlavorStore';

export const Wrapper = styled.header`
  position: relative;
  margin-bottom: 30rem;

  height: fit-content;
  width: fit-content;
`;

const Number = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-30%, -50%);

  font-size: 30rem;
  font-weight: bold;
`;

const Label = styled.h2(({ $align }: { $align: "left" | "right" }) => `
  position: absolute;
  top: 50%;
  ${$align}: 100%;

  font-size: 22rem;
  white-space: nowrap;

  @media screen and (min-width: ${viewport.sm}) { font-size: 19rem }
  @media screen and (min-width: ${viewport.lg}) { font-size: 22rem }
  @media screen and (min-width: ${viewport.xl}) { font-size: 24rem }
`);

const Heading = ({ number, label, align }: {
  number: string,
  label: string,
  align: "left" | "right"
}) => {

  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  return (
    <Wrapper>
      <HandwriteCircle active color={`var(--${flavor})`} />
      <Number>{number}</Number>
      <Label $align={align}>{label}</Label>
    </Wrapper>
  );
}

export default Heading;